// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__-_B0N","select":"Header_select__2hZcK","clinic":"Header_clinic__3Uu8i"};